var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuM03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2992 1H20.1267V18.4246H25.2992V1Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4101 5.08423H12.2375V18.4248H17.4101V5.08423Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52067 9.16821H4.34814V18.4248H9.52067V9.16821Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6477 26.8241C28.6477 34.4566 22.4607 40.648 14.8239 40.648C7.187 40.648 1 34.4566 1 26.8241C1 19.1916 7.187 13.0002 14.8239 13.0002C22.4607 13.0002 28.6477 19.1872 28.6477 26.8241Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8994 26.8521H16.2187C17.2718 26.8521 18.1182 27.8917 18.1182 29.1714C18.1182 30.451 17.2651 31.4907 16.2187 31.4907H13.8994C12.8531 31.4907 12 30.451 12 29.1714",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2187 26.852H13.8994C12.8531 26.852 12 25.8123 12 24.5327C12 23.2531 12.8531 22.2134 13.8994 22.2134H16.2187C17.2718 22.2134 18.1182 23.2531 18.1182 24.5327",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0581 31.5239V33.7033",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0581 20.0002V22.1729",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 35.0398V34.9875C32.906 34.9875 32.906 35.005 32.906 35.0137C32.906 35.0224 32.906 35.0311 32.906 35.0398Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 34.9653C32.906 34.9653 32.906 34.9784 32.906 34.9871V34.9653Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0766 37.1815C23.859 37.1815 21.2466 36.2236 21.2466 35.0393V38.8577C21.2466 40.042 23.8546 40.9999 27.0766 40.9999C30.2985 40.9999 32.9065 40.042 32.9065 38.8577C32.9065 38.8316 32.9065 38.8055 32.9022 38.7794V35.0393C32.9022 36.2192 30.2941 37.1771 27.0809 37.1771L27.0766 37.1815Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9019 34.9653C32.9019 34.9653 32.9019 34.9261 32.9019 34.9087V34.9653Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9019 35.0181C32.9019 35.0181 32.9019 35.0007 32.9019 34.992C32.9019 34.992 32.9019 34.9746 32.9019 34.9702C32.9019 34.9702 32.9019 35.005 32.9019 35.0225V35.0181Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 35.044V35.0393V35.044Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 31.147C32.906 31.147 32.906 31.16 32.906 31.1687V31.147Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 31.2207V31.1685C32.906 31.1685 32.906 31.1859 32.906 31.1946C32.906 31.2033 32.906 31.212 32.906 31.2207Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2466 34.9653V34.9871C21.2466 34.9871 21.2466 34.9697 21.2466 34.9653Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0766 37.1297C23.859 37.1297 21.2466 36.1718 21.2466 34.9875V35.0398C21.2466 36.2241 23.8546 37.182 27.0766 37.182C30.2985 37.182 32.9022 36.2241 32.9065 35.0442C32.9065 35.0442 32.9065 35.0224 32.9065 35.018C32.8673 36.1849 30.2724 37.1297 27.0809 37.1297H27.0766Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.902 34.9652V31.2251C32.902 32.0393 31.6741 32.7446 29.8585 33.106C29.0313 33.2715 28.0865 33.3629 27.0807 33.3629C26.0749 33.3629 25.1301 33.2671 24.3029 33.106C22.4873 32.7446 21.2507 32.0349 21.2507 31.2251V34.9695C21.2507 34.9695 21.2507 34.9826 21.2507 34.9913C21.2507 36.1756 23.8588 37.1334 27.0807 37.1334C30.3026 37.1334 32.8671 36.1886 32.9063 35.0218C32.9063 35.0043 32.9063 34.9869 32.9063 34.9695L32.902 34.9652Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9019 31.1469C32.9019 31.1469 32.9019 31.1077 32.9019 31.0903V31.1469Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9019 31.1949C32.9019 31.1949 32.9019 31.1775 32.9019 31.1687C32.9019 31.1687 32.9019 31.1557 32.9019 31.147C32.9019 31.147 32.9019 31.1818 32.9019 31.1949Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2466 27.3286V27.3504C21.2466 27.3504 21.2466 27.3373 21.2466 27.3286Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 27.3286C32.906 27.3286 32.906 27.3417 32.906 27.3504V27.3286Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.906 31.2256V31.2209V31.2256Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7104 33.0801C29.7583 33.0888 29.8062 33.0976 29.8541 33.1063C31.6697 32.7449 32.9019 32.0395 32.9063 31.2253C32.9063 31.2253 32.9063 31.2079 32.9063 31.1992C32.8758 32.0221 31.587 32.7318 29.7148 33.0801H29.7104Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2987 33.1065C24.3466 33.0978 24.3945 33.0891 24.4424 33.0804C22.5484 32.7277 21.2466 32.0049 21.2466 31.1733V31.2256C21.2466 32.0398 22.4788 32.7451 24.2987 33.1065Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2466 31.147V31.1687C21.2466 31.1687 21.2466 31.1557 21.2466 31.147Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.442 33.0798C24.3941 33.0885 24.3462 33.0972 24.2983 33.106C25.1256 33.2714 26.0704 33.3628 27.0762 33.3628C28.0819 33.3628 29.0268 33.2671 29.854 33.106C29.8061 33.0972 29.7582 33.0885 29.7103 33.0798C28.9179 33.2279 28.0253 33.3106 27.0762 33.3106C26.127 33.3106 25.2344 33.2279 24.442 33.0798Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.902 31.1468V27.3501C32.9063 28.1861 31.6088 28.9045 29.7149 29.2615C28.9224 29.4095 28.0299 29.4923 27.0807 29.4923C26.1315 29.4923 25.239 29.4095 24.4465 29.2615C22.5526 28.9088 21.2507 28.1861 21.2507 27.3501V31.1468C21.2507 31.1468 21.2507 31.1598 21.2507 31.1685C21.2507 32.0001 22.5482 32.7229 24.4465 33.0756C25.239 33.2236 26.1315 33.3063 27.0807 33.3063C28.0299 33.3063 28.9224 33.2236 29.7149 33.0756C31.5871 32.7273 32.8802 32.0176 32.9063 31.1947C32.9063 31.1772 32.9063 31.1598 32.9063 31.1468H32.902Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9061 27.3284C32.8756 26.1572 30.2763 25.208 27.0805 25.208C23.8847 25.208 21.2854 26.1572 21.2549 27.3284C21.2549 27.3371 21.2549 27.3415 21.2549 27.3502C21.2549 28.1861 22.5567 28.9045 24.4507 29.2616C25.2431 29.4096 26.1357 29.4923 27.0849 29.4923C28.034 29.4923 28.9266 29.4096 29.719 29.2616C31.613 28.9089 32.9148 28.1861 32.9148 27.3502C32.9148 27.3502 32.9148 27.3371 32.9148 27.3284H32.9061Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuM03);
export default __webpack_public_path__ + "static/media/ic_mo_menu_m03.b766face5fd5a5879db0ab0bb8ce4079.svg";
export { ForwardRef as ReactComponent };